import React from "react";
import HelpMedia from "./HelpMedia";

const HelpSubnetwork = () => {
  return (
    <div className="pt-3">
      <h3>Subnetwork Page</h3>
      <p>
        The Subnetwork page displays genes that are directly connected to the gene of interest as well as
        neighboring genes that are indirectly connected to the gene of interest via one or two additional genes/nodes.
      </p>
      <p>
        Gene nodes in a subnetwork are colored according to biological processes represented in the global HAP1
        network and identified using
        <a href="https://doi.org/10.1016/j.cels.2016.04.014" target="_blank" rel="noreferrer"
           className="text-decoration-none"> SAFE</a>. Nodes in a subnetwork annotated to the same functional term
        will be colored similarly.
      </p>

      <h5 className="mt-4">Key Features:</h5>
      <ul>
        <li>Explore genetic interaction profile similarity connections for a given gene(s) of interest in more detail</li>
        <li>Display direct and indirect neighbors based on profile similarity</li>
        <li>Adjust the PCC threshold to reveal or hide genes based on strength of profile similarity</li>
        <li>Use the same features found in the Global Network: Node actions, Zoom & Pan controls, and Screen Capture</li>
      </ul>

      <h5 className="mt-4">How to Use:</h5>
      <div className="mb-4">
        <h6 className="fw-semibold">1. Switch from Global Network to Subnetwork view</h6>
        <p>
          After selecting genes in the Global Network, click the "Subnetwork View" button to switch the page.
        </p>
        <HelpMedia
          src={`${process.env.PUBLIC_URL}/videos/help/subnetwork_switch_from_network.webm`}
          poster={`${process.env.PUBLIC_URL}/images/help/subnetwork_switch_from_network.png`}
          alt="Subnetwork View - Landing Page"
        />
      </div>
      <div className="mb-4">
        <h6 className="fw-semibold">2. Update Gene Selection</h6>
        <ul>
          <li>Add more genes by typing in the search bar</li>
          <li>Remove a gene from the selection by clicking the X button beside the gene name</li>
        </ul>
        <HelpMedia
          src={`${process.env.PUBLIC_URL}/videos/help/subnetwork_update_selected_genes.webm`}
          poster={`${process.env.PUBLIC_URL}/images/help/subnetwork_update_selected_genes.png`}
          alt="Updating Gene Selection"
        />
      </div>
      <div className="mb-4">
        <h6 className="fw-semibold">3. Adjust the PCC Threshold</h6>
        <p>
          Manually adjust the PCC threshold applied to a profile similarity subnetwork by either using the slider
          bar or by typing the new threshold value in the dialog box.
        </p>
        <HelpMedia
          src={`${process.env.PUBLIC_URL}/videos/help/subnetwork_adjust_pcc.webm`}
          poster={`${process.env.PUBLIC_URL}/images/help/subnetwork_adjust_pcc.png`}
          alt="Updating Gene Selection"
        />
      </div>
    </div>
  );
}

export default HelpSubnetwork;